import { z } from 'zod';

/////////////////////////////////////////
// CODE ENFORCEMENT VIOLATION SCHEMA
/////////////////////////////////////////

export const CodeEnforcementViolationSchema = z.object({
  violationId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  violationTypeId: z.number().int(),
  violationGrouping: z.string(),
  dateViolationDue: z.coerce.date(),
  violationStatus: z.string(),
  dateViolationClosed: z.coerce.date(),
  details: z.string(),
  violationUnit: z.string(),
  violationRoom: z.string(),
  externalId: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type CodeEnforcementViolation = z.infer<typeof CodeEnforcementViolationSchema>

export default CodeEnforcementViolationSchema;
